import React, { useState, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import "antd/dist/antd.css";
import { Menu, Dropdown, Icon } from "antd";
import { decodeHtmlEntities } from "utils/decodeHtmlEntities";

const cardStyle = {
  width: "100%",
  border: "none",
  borderRadius: "10px",
  backgroundColor: "#F7F6F6",
  marginTop: "10px",
  padding: 10,
  paddingLeft: "30px",
  paddingRight: "30px",
};

export const DataSourcesDetails = ({ t, dataAgreement }) => {
  const [selectedSector, setSelectedSector] = useState(null);

  const sectors = useMemo(() => {
    if (!dataAgreement.dataSources) return [];
    const sectorSet = new Set(dataAgreement.dataSources.map((ds) => ds.sector));
    return Array.from(sectorSet);
  }, [dataAgreement.dataSources]);

  const menu = (
    <Menu onClick={({ key }) => setSelectedSector(key === "all" ? null : key)}>
      <Menu.Item key="all">{t("dataAgreements.allSectors")}</Menu.Item>
      {sectors.map((sector) => (
        <Menu.Item key={sector}>{sector}</Menu.Item>
      ))}
    </Menu>
  );

  const filteredDataSources = useMemo(() => {
    if (!selectedSector) return dataAgreement.dataSources;
    return dataAgreement.dataSources.filter(
      (ds) => ds.sector === selectedSector
    );
  }, [dataAgreement.dataSources, selectedSector]);

  return (
    <div>
      <Dropdown overlay={menu} trigger={["click"]}>
        <p
          style={{ color: "grey", fontSize: "15px", cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          {t("dataAgreements.sector")}:{" "}
          {decodeHtmlEntities(selectedSector) || t("dataAgreements.all")}{" "}
          <Icon type="down" />
        </p>
      </Dropdown>

      {filteredDataSources &&
        filteredDataSources.map((dataSource, i) => (
          <div style={cardStyle} key={i}>
            <p style={{ fontSize: "14px" }}>
              {decodeHtmlEntities(dataSource.name)}
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <p style={{ margin: 0, color: "grey" }}>
                {decodeHtmlEntities(dataSource.sector)},&nbsp;&nbsp;
              </p>
              <p style={{ margin: 0, color: "grey" }}>
                {decodeHtmlEntities(dataSource.location)}
                {dataSource.privacyDashboardUrl && ","}&nbsp;&nbsp;
              </p>
              <a
                href={dataSource.privacyDashboardUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  margin: 0,
                  color: "1890FF",
                  textDecoration: "none",
                }}
              >
                {dataSource.privacyDashboardUrl}
              </a>
            </div>
          </div>
        ))}
    </div>
  );
};

export const DataSourcesDetailsWithNamespace = withNamespaces()(
  DataSourcesDetails
);

export default DataSourcesDetails;
